import React, { Component } from 'react';
import { Button, Container, Divider, Form, Grid, Header, Message, Segment } from 'semantic-ui-react'
import { callService, GET, PATCH } from "../../shared/serviceInvoker";
import { contactDataURL } from "../../shared/urls/clientapi";
import { checkEmail, checkRequired } from "../../shared/helpers/validators";
import MessageError from "../../shared/components/MessageError";
import MessageSuccess from "../../shared/components/MessageSuccess";
import FormSelect from "../../shared/components/FormSelect";
import ChangePassword from "../ChangePassword";
import { returnErrorMessage } from "../../shared/utils";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.myContactDataURL = contactDataURL.replace('{contact_id}', sessionStorage.contact_id);

    var disableChangePassword = false;
    if (sessionStorage.getItem("isImpersonating")) {
      disableChangePassword = sessionStorage.getItem("isImpersonating") === 'true';
    }

    this.state = {
      success: false,
      error: false,
      errorMessage: '',

      first_name: '',
      middle_name: '',
      last_name: '',
      suffix_name: '',
      co_applicant_first_name: '',
      co_applicant_middle_name: '',
      co_applicant_last_name: '',
      co_applicant_suffix_name: '',
      email: '',
      phone_number: '',
      mobile_number: '',
      address_1: '',
      address_2: '',
      city: '',
      state: '',
      zip_code: '',

      formValid: false,

      emailValid: false,
      phoneNumberOrMobileNumberRequired: false,

      address1Required: false,
      cityRequired: false,
      stateRequired: false,
      zipCodeRequired: false,

      passwordSection: false,
      showSuccessMsg: false,
      disableChangePassword: disableChangePassword
    };

    callService(
      GET,
      this.myContactDataURL,
      {},
      response => {
        if (response.data.data) {
          const data = response.data.data;
          this.setState(
            {
              first_name: data.first_name,
              middle_name: data.middle_name,
              last_name: data.last_name,
              suffix_name: data.suffix_name,
              co_applicant_first_name: data.co_applicant_first_name,
              co_applicant_middle_name: data.co_applicant_middle_name,
              co_applicant_last_name: data.co_applicant_last_name,
              co_applicant_suffix_name: data.co_applicant_suffix_name,
              email: data.email,
              phone_number: data.phone_number,
              mobile_number: data.mobile_number,
              address_1: data.address_1,
              address_2: data.address_2,
              city: data.city,
              state: data.state,
              zip_code: data.zip_code,
            }
          );
          this.validateField('email', data.email);
          this.validateField('phone_number', data.phone_number);
          this.validateField('mobile_number', data.mobile_number);
          this.validateField('address_1', data.address_1);
          this.validateField('address_2', data.address_2);
          this.validateField('city', data.city);
          this.validateField('state', data.state);
          this.validateField('zip_code', data.zip_code);
        }
      },
      error => {
        this.setState({ error: true });
      },
    );

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNumberOnlyChange = this.handleNumberOnlyChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.togglePasswordSection = this.togglePasswordSection.bind(this);
    this.passwordChangeSuccess = this.passwordChangeSuccess.bind(this);
  }

  componentDidMount() {
    this.props.updatenav("profile");
  }

  passwordChangeSuccess() {
    this.setState({ passwordSection: false, showSuccessMsg: true });
  }

  togglePasswordSection(event) {
    const passwordSection = this.state.passwordSection;
    event.preventDefault();
    this.setState({ passwordSection: !passwordSection, showSuccessMsg: false });
  }

  handleNumberOnlyChange(event) {
    const target = event.target;
    const value = target.value.replace(/\D/, '');
    const name = target.name;

    this.setState(
      { [name]: value },
      () => { this.validateField(name, value) }
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      { [name]: value },
      () => { this.validateField(name, value) }
    );
  }

  handleSelectChange(event) {
    const target = event.target;
    const value = target.innerText;
    const name = target.name;
    this.setState(
      { [name]: value },
      () => { this.validateField(name, value) }
    );
  }

  validateField(fieldName, value) {
    let emailValid = this.state.emailValid;
    let phoneNumberOrMobileNumberRequired = this.state.phoneNumberOrMobileNumberRequired;
    let address1Required = this.state.address1Required;
    let cityRequired = this.state.cityRequired;
    let stateRequired = this.state.stateRequired;
    let zipCodeRequired = this.state.zipCodeRequired;

    switch (fieldName) {
      case 'email':
        emailValid = checkEmail(value);
        break;
      case 'mobile_number':
      case 'phone_number':
        phoneNumberOrMobileNumberRequired = !!(this.state.phone_number || this.state.mobile_number);
        break;
      case 'address_1':
        address1Required = checkRequired(value);
        break;
      case 'city':
        cityRequired = checkRequired(value);
        break;
      case 'state':
        stateRequired = checkRequired(value);
        break;
      case 'zip_code':
        zipCodeRequired = checkRequired(value);
        break;
      default:
        break;
    }
    this.setState(
      {
        emailValid: emailValid,
        phoneNumberOrMobileNumberRequired: phoneNumberOrMobileNumberRequired,
        address1Required: address1Required,
        cityRequired: cityRequired,
        stateRequired: stateRequired,
        zipCodeRequired: zipCodeRequired
      },
      this.validateForm
    )
  }

  validateForm() {
    this.setState(
      {
        formValid: this.state.emailValid && this.state.phoneNumberOrMobileNumberRequired && this.state.address1Required
          && this.state.cityRequired && this.state.stateRequired && this.state.zipCodeRequired
      }
    )
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { email, phone_number, mobile_number, address_1, address_2, city, state, zip_code } = this.state;

    let bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('phone_number', phone_number);
    bodyFormData.append('mobile_number', mobile_number);
    bodyFormData.append('address_1', address_1);
    bodyFormData.append('address_2', address_2);
    bodyFormData.append('city', city);
    bodyFormData.append('state', state);
    bodyFormData.append('zip_code', zip_code);

    callService(
      PATCH,
      this.myContactDataURL,
      bodyFormData,
      response => {
        this.setState({ success: true, error: false });

        ReactGA.event({
          category: 'Profile',
          action: 'Profile Info Updated',
        });
        trackEvent('Profile', 'Profile Info Updated');
      },
      error => {
        let msg = returnErrorMessage(error, "DefaultSaveError");
        this.setState({ success: false, error: true, errorMessage: msg });
      }
    );
  };

  render() {
    const errors = {
      email: 'Enter a valid email address.',
      phone: 'At least one of the numbers is required.',
      address1: 'This field is required.',
      city: 'This field is required.',
      state: 'This field is required.',
      zipCode: 'This field is required.',
    };

    return (
      <div>
        <Divider hidden />

        <Container>

          <Grid style={{ height: '100%' }} textAlign='center'>
            <Grid.Column style={{ maxWidth: 450 }} textAlign='left'>

              <Container>
                <Header as='h1' textAlign='left'>Profile
                <Header.Subheader>* Required</Header.Subheader>
                </Header>
                <Divider hidden />
                <Grid>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      &nbsp;
                    </Grid.Column>
                    <Grid.Column>
                      <Header as='h4'>Client</Header>
                    </Grid.Column>
                    <Grid.Column>
                      <Header as='h4'>Co-Applicant</Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      ID
                    </Grid.Column>
                    <Grid.Column>
                      {sessionStorage.getItem("contact_id")}
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      Legal First Name
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.first_name}
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.co_applicant_first_name}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      Middle Name
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.middle_name}
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.co_applicant_middle_name}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      Last Name
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.last_name}
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.co_applicant_last_name}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      Suffix (Jr, Esq, etc)
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.suffix_name}
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.co_applicant_suffix_name}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

              </Container>
              <Divider />
              <Divider hidden />

              <Container>
                <Header>Security</Header>
                <Grid verticalAlign='middle'>
                  <Grid.Row>
                    <Grid.Column width={7}>
                      <Button primary onClick={this.togglePasswordSection} disabled={this.state.disableChangePassword} >
                        {
                          this.state.passwordSection ? 'Hide section' : 'Change Password'
                        }
                      </Button>
                    </Grid.Column>
                    <Grid.Column width={9}>
                      {
                        this.state.showSuccessMsg ?
                          <MessageSuccess icon message="Password Changed Successfully" />
                          : null
                      }
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {
                  this.state.passwordSection ?
                    <div>
                      <Divider hidden />
                      <Segment>
                        <ChangePassword onSuccess={this.passwordChangeSuccess} />
                      </Segment>  
                    </div>
                    :
                    null
                }
              </Container>
              <Divider />
              <Divider hidden />

              <Form onSubmit={this.handleSubmit}>
                <Container>
                  <Header as='h3'>
                    Contact
                    <Header.Subheader>
                      This will be our primary way of contacting you with important information, so please keep it current.
                    </Header.Subheader>
                  </Header>

                  <label htmlFor="email" style={{ display: 'block', textAlign: 'left' }}>
                    Email **
                  </label>
                  <Form.Input
                    name='email'
                    value={this.state.email}
                    type='text'
                    onChange={this.handleInputChange}
                    maxLength={40}
                    className={this.state.emailValid ? 'text-input' : 'text-input error'}
                  />
                  {!this.state.emailValid ? <MessageError message={errors.email} /> : null}
                  <Divider hidden />

                  <label htmlFor="mobile_number" style={{ display: 'block', textAlign: 'left' }}>
                    Mobile Phone **
                  </label>
                  <Form.Input
                    name='mobile_number'
                    value={this.state.mobile_number}
                    type='text'
                    onChange={this.handleNumberOnlyChange}
                    maxLength={10}
                    className={this.state.phoneNumberOrMobileNumberRequired ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.phoneNumberOrMobileNumberRequired ?
                      <MessageError message={errors.phone} />
                      :
                      null
                  }
                  <Divider hidden />

                  <label htmlFor="phone_number" style={{ display: 'block', textAlign: 'left' }}>
                    Home Phone **
                  </label>
                  <Form.Input
                    name='phone_number'
                    value={this.state.phone_number}
                    type='text'
                    onChange={this.handleNumberOnlyChange}
                    maxLength={10}
                    className={this.state.phoneNumberOrMobileNumberRequired ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.phoneNumberOrMobileNumberRequired ?
                      <MessageError message={errors.phone} />
                      :
                      null
                  }

                  <Header as='h3'>
                    <Header.Subheader> ** At least one phone number is required.</Header.Subheader>
                  </Header>
                </Container>

                <Divider hidden />
                <Container>
                  <Header as='h3'>
                    Address
                    <Header.Subheader>
                      From time to time we may have important physical documents to send to you.
                    </Header.Subheader>
                  </Header>

                  <label htmlFor="address_1" style={{ display: 'block', textAlign: 'left' }}>
                    Address *
                  </label>
                  <Form.Input
                    name='address_1'
                    value={this.state.address_1}
                    type='text'
                    onChange={this.handleInputChange}
                    maxLength={50}
                    className={this.state.address1Required ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.address1Required ?
                      <MessageError message={errors.address1} />
                      :
                      null
                  }
                  <Divider hidden />

                  <label htmlFor="address_2" style={{ display: 'block', textAlign: 'left' }}>
                    Address 2
                  </label>
                  <Form.Input
                    name='address_2'
                    value={this.state.address_2}
                    type='text'
                    onChange={this.handleInputChange}
                    maxLength={50}
                    className='text-input'
                  />
                  <Divider hidden />

                  <label htmlFor="city" style={{ display: 'block', textAlign: 'left' }}>
                    City *
                  </label>
                  <Form.Input
                    name='city'
                    value={this.state.city}
                    type='text'
                    onChange={this.handleInputChange}
                    maxLength={50}
                    className={this.state.cityRequired ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.cityRequired ?
                      <MessageError message={errors.city} />
                      :
                      null
                  }
                  <Divider hidden />

                  <label htmlFor="state" style={{ display: 'block', textAlign: 'left' }}>
                    State *
                  </label>
                  <FormSelect
                    name='state'
                    value={this.state.state}
                    onChange={this.handleInputChange}
                    className={this.state.stateRequired ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.stateRequired ?
                      <MessageError message={errors.state} />
                      :
                      null
                  }
                  <Divider hidden />

                  <label htmlFor="zip_code" style={{ display: 'block', textAlign: 'left' }}>
                    Zip Code *
                  </label>
                  <Form.Input
                    name='zip_code'
                    value={this.state.zip_code}
                    type='text'
                    onChange={this.handleNumberOnlyChange}
                    maxLength={10}
                    className={this.state.zipCodeRequired ? 'text-input' : 'text-input error'}
                  />
                  {
                    !this.state.zipCodeRequired ?
                      <MessageError message={errors.zipCode} />
                      :
                      null
                  }
                  <Divider hidden />
                </Container>

                <Divider />
                <Container>
                  {
                    this.state.success ?
                      <Message size='tiny' color='green' icon='checkmark' content='Data saved successfully!' />
                      : null
                  }
                  {
                    this.state.error ?
                      <Message size='tiny' color='red'>
                        <div dangerouslySetInnerHTML={{ __html: this.state.errorMessage }} />
                      </Message>
                      : null
                  }
                  <Button
                    icon='save'
                    type='submit'
                    primary
                    disabled={!this.state.formValid}
                    content='Save'
                  />

                </Container>
              </Form>
            </Grid.Column>
          </Grid>
        </Container>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/index.js